
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface SidebarHeaderProps {
    title: string;
    description: string;
  }

  export default defineComponent<SidebarHeaderProps>({
    components: { Icon },
    props: ['title', 'description'],
    emits: ['close'],
  });
